module.exports = {
  menu : {
    AccountCenter:"个人中心",
    EmployeeManagement:'员工管理',
    EmailAddress:'邮箱',
    Password:'密码',
    Login:'登录',
    ForgotPassword:'忘记密码',
    UserName:'用户',
    Distributor:'所属经销商',
    Role:'角色',
    ChangePassword:'修改密码',
    AddAccount:'添加账号',
    Edit:'编辑',
    Delete:'删除',
    DeleteAccount:'删除账号',
    DelAc:'删除账号后该成员将不能继续使用，确定删除？',
    FrameNumber:'车架号',
    EngineNumber:'发动机号',
    State:'状态',
    StorageDate:'入库时间',
    SaleDate:'销售时间',
    Operation:'操作',
    Register:'注册',
    Details:'详情',
    Export:'导出',
    Download:'下载',
    VehicleName:'车辆名称',
    Colour:'颜色',
    Distributor:'经销商',
    DeliveryDate:'入库时间',
    CustomerInformation:'客户信息',
    CustomerType:'客户类型',
    licensePlateNumber:'车牌号',
    contactNumber:'联系电话',
    EmailAddress:'电子邮箱',
    Address:'地址',
    PictureMaterials:'图片材料',
    Save:'保存',
    Cancel:'取消',
    Modify:'修改',
    PurchasementOfAccessoires:'周边品采购',
    ApplicableModels:'适用车型',
    All:'全部',
    AddToCart:'加入购物车',
    SoldOut:'已售罄',
    Attachment:'附件',
    MinimumPurchaseQuantity:'最小采购量',
    MinimumPurchaseQuantitya:'最小采购量',
    UnitUsage:'单元用量',
    Alternative:'替换件',
    ShoppingCart:'购物车',
    Code:'编码',
    Income:'收入',
    Remarksaa:'拒绝原因',
    Product:'产品',
    VehicleModel:'车型',
    UnitPrice:'单价',
    Quantity:'数量',
    Quantitya:'小计',
    SubTotal:'小计',
    InvalidProduct:'无效商品',
    ClearInvalidProducts:'清空无效商品',
    PaymentMethod:'支付方式',
    FreightMode:'货运方式',
    PriceTerms:'价格条款',
    TransferAccounts:'银行转账',
    AccountPayment:'账户支付',
    Remarks:'备注',
    Tips:'提示',
    CheckoutSuccess:'下单成功',
    DeliveryAddress:'收件地址',
    Country:'国家',
    Addressee:'收件人',
    OrderNumber:'单号',
    Currency:'币种',
    PurchaseAmount:'采购金额',
    DeliveryProgress:'发货进度',
    Paymentmethod:'结算方式',
    SettlementInformation:'结算信息',
    PaymentInformation:'支付信息',
    SettlementStatus:'结算状态',
    FeeTotal:'合计',
    OrderTime:'下单时间',
    PendingReview:'待审核',
    Underreview:'审核中',
    PendingShipment:'待发货',
    UnderDelivery:'发货中',
    Completed:'已完结',
    ContractNumber:'合同号',
    PriceTerms:'价格条款',
    ProductDetails:'产品明细',
    AddTo:'添加',
    NO:'序号',
    PartCode:'配件编码',
    PartName:'配件名称',
    OrderAmount:'订单金额',
    AddParts:'添加配件',
    DeliveryDetails:'发货明细',
    ClaimOrder:'理赔订单',
    ClaimNumber:'索赔单号',
    Vehicle:'车辆',
    FrameNo:'车辆',
    ClaimType:'索赔类型',
    ClaimAmount:'索赔金额',
    ApplicationTime:'申请时间',
    ClaimRecord:'索赔记录',
    OperationRecord:'操作记录',
    Amount:'金额',
    Operator:'操作人',
    OperationContent:'操作内容',
    TransactionSerialNumber:'流水单号',
    TransactionOrderNumber:'业务单号',
    TransactionType:'流水类型',
    IncomeAndExpenditureTypes:'收支类型',
    AmountChanges:'变动金额',
    Time:'时间',
    DocumentCenter:'文档中心',
    ScopeOfApplication:'适用范围',
    Title:'标题',
    ReleaseTime:'发布时间',
    Preview:'预览',
    Bulletin:'公告通知',
    Type:'类型',
    Receive:'签收',
    LaborHourList:'工时列表',
    ApplyForClaim:'申请索赔',
    ProductName:'产品名称',
    WarrantyPeriod:'质保期限',
    Customer:'客户',
    Dealer:'售出经销商',
    ClaimInformation:'索赔信息',
    EventName:'活动名称',
    Mileage:'行驶里程',
    ProblemDescription:'故障描述',
    Analysis:'原因分析',
    Solution:'解决方案',
    ClaimDetails:'索赔明细',
    RepairType:'维修类型',
    ClaimForLaborHour:'索赔工时',
    StandardLaborCost:'标准工时费',
    LaborHours:'工时',
    LaborCost:'工时费',
    SupportClaims:'支持索赔',
    LobarHourCode:'工时编码',
    CHDescriptionOfLaborHours:'工时中文名称',
    ENDescriptionOfLaborHours:'工时英文名称',
    StandardLaborHours:'标准工时',
    InUse:'使用中',
    Deactivated:'已停用',
    LogOff:'退出登录',
    ExpectedShippingdate:'期望发货日期',
    CustomerOrderNo:'计划号',
    Kind:'商品',
    Rejected:'已拒绝',
    Cancelled:'已取消',
    ExportOrder:'导出订单',
    ExportDetails:'导出明细',
    Expense:'支出',
    Onlyunread:'只显示未读',
    user:'用户账号',
    Confirm:'确定',
    Inputthepassword:'请输入密码',
    Basicinformation:'基础信息',
    search:'查询',
    Claim:'客诉单号',
    Bykeywords:'请输入关键词查找',
    Startdata:'开始时间',
    Enddata:'结束时间',
    to:'至',
    EntertheVIN:'请输入车架号...',
    Add:'加入',
    SUCESS:'添加成功',
    unit:'默认单车用量',
    Effectivedate:'生效日期',
    Bymodel:'选择车型',
    ByVIN:'按车架号搜索',
    Bypart:'按配件搜索',
    Country:'出口国别',
    Shippingtype:'请选择货运方式',
    Expected:'选择日期',
    Enter:'请输入',
    Submit:'提交订单',
    Uploadorder:'批量导入',
    OrderNo:'配件单号',
    Countrya:'国别',
    Reapply:'重新申请',
    ItemNo:'项号',
    Accountdeduction:'售后账户支付',
    Continueordering:'继续下单',
    Orderdetails:'查看订单',
    Soldout:'已停售',
    Total:'共',
    items:'条',
    uesr:'账户名称',
    item:'件',
    yjcll:'已处理',
    Import:'导入',
    CustomerName:'客户名称',
    MOQ:'最小起订量',
    PartsImportTemplate:'模板',
    SelectFile:'选择文件',
    ShipmentInformation:'发货信息',
    ShipmentNo:'发货单号',
    Qty:'配件数量',
    ShipmentDate:'发货日期',
    NoVehiclePartsInformationFound:'未查询到车辆配件信息',
    Novehiclemodelinformation :'未查询到车型信息，不支持该车辆理赔',
    Pleaseentertheframe:'请先输入车辆信息',
    Reset:'重置',
    BulkRegistration:'批量注册',
    Importtemplate:'模版',
   
    Claimedpart:'索赔配件',
    Uploadfiles:'点击上传',
    Note10M:'注：可上传多个文件，支持上传pdf、doc、docx格式文件，且单个文件大小不能超过10M',
    Submitsuopei:'提交申请',
    Cancelsuopei:'取消申请',
    AfterSalesAccountCurrency:'售后结算币种',
    Success:'提交成功',
    Continue:'继续申请',
    Viewtheorder:'查看订单',
    Unread:'待接收',
    Approved:'已通过',
    Rejected2:'已驳回',
    Saletime:'销售日期',
    Timecaozuo:'操作时间',
    RegistrationDate:'注册时间',
    Unregistered:'未售出',
    Registered:'已售出',
    Mileage2:'行驶公里',
    Failurecategory:'故障类别',
    Underreview11:'技术驳回',
    Underreview2:'待技术判定',
    Partcategory:'配件分类',
    Underreview3:'钉钉审批中',
    Underreview4:'待售后审核',
    Country1:'申请国别',
    Reasons:'驳回原因',
    Vehicleorder:'整车订单',
    Partsorder:'配件订单',
    Parts:'配件',
    Vehicle:'整车',


lingshouzhanghzf:'零售账户支付',
    zcmxcx:'车型',
    zcmxyhxm:'用户姓名',
    zcmxlsh:'零售商',
    zcmxzbdqsj:'质保到期时间',
    zcmxyczbqx:'延长质保期限',

    zckckccz:'库存充足',
    zckckcjz:'库存紧张',
    zckczwkc:'暂无库存',
    zckccx:'车型',
    zckcyc:'颜色',
    zckcdqkc:'当前库存',
    zckckcxx:'库存下限',
    zckczt:'状态',
    zckccz:'操作',
    zckcyjsz:'预警设置',

    wbdtj:'添加维保单',
    wbddh:'维保单号',
    wbdlc:'车辆里程',
    wbdlss:'服务零售商',
    wbdsj:'服务时间',
    wbdyfw:'已服务',
    wbdylxr:'联系人',
    wbdylxfs:'联系方式',
    wbdyfwxm:'服务项目',
    wbdymx:'明细',
    wbdysypj:'使用配件',
    cldasclss:'售出零售商',
    
    cgwdpjdh:'配件单号',
    cgwdxdrq:'下单日期',
    cgwdlx:'类型',
    cgwdpjbm:'配件编码',
    cgwdpjmc:'配件名称',
    cgwddgsl:'订购数量',
    cgwdyfh:'已发货数量',
    cgwdwd:'尾单',

    lssjxsmc:'零售商全称',
    lssyx:'邮箱',
    lsszt:'状态',
    lsserp:'ERP账号绑定',
    
    fbwdwjlx:'文件类型',
    fbwdsc:'上传',
    fbwfbr:'发布人',
    xspjfl:'分类',
    xspjsscx:'所属车型',
    xspjfy:'翻译',
    xspjxsj:'销售价',
    xspjghgs:'更换工时费',
    xspjwxgs:'维修工时费',
   xscxjg:'价格',
    
   zhglbm:'账户编码',
   zhgllx:'账户类型',
   zhglyem:'账户余额',
   zhglls:'流水明细',

   fhdfhsj:'发货时间',
   fhddh:'发货单号',
   fhdglpj:'关联配件订单',
   fhdfhsl:'发货数量',
   shtgs:'审核通过数',
   sqsl:'申请数量',
   sqyb:'申请延保',
   zsddlx:'订单类型',
   sousuo:'搜索',
   cbjg:'成本价格',
   erpzd:'制单',
   zwshj:'暂无数据',
   clmxl:'车辆明细',
   clstme:'处理时间',
   dqzbsj:'当前质保时间',
   ycnx:'延长年限',
   ychdqsj:'延长后到期时间',
    yczbpoz:'延长质保凭证文件',
    tgl:'通过',
    jul:'拒绝',
    pfzl:'赔付中',
    ypfl:'已赔付',
    dkhqrl:'待客户确认',
    khjc:'零售商简称',
    khjca:'零售商简称/全称',
    chejiahao:'车架号',
    dailipei:'待理赔',
    yilipei:'已理赔',
    suopeishukl:'索赔数量',
    yipeifusl:'已赔付数量',
    dipeifusl:'待赔付数量',
    xiaoshoudh:'销售单号',
    quxiaolip:'取消理赔',
    zhgengchefahg:'整车发货',
    peijianfh:'配件发货',
    daizhid:'待制单',
    tongzhiduix:'通知对象',
    quanbulss:'全部零售商',
    zhidingreny:'指定人员',
    mingxc:'名称',
    congnir:'内容',
    fabutongg:'发布通知',
    xiuggtongg:'修改通知',
   weibaojil:'维保记录',
    weibaoshijian:'维保时间',
  shengchengpeiqdan:'生成配件订单',
  chuangjianxiaosd:'创建销售单',
  peijianmingxi:'配件明细',
  bencipeifus:'本次赔付数量',
  peijianzongs:'配件总数',
  kehugongsi:'客户公司',
  fahuod:'发货单',
  changchuanvin:'上传车架号',
  xiazaimuban:'下载模板',
  daifashul:'待发数量',
  bencufahuo:'本次发货',
  fahuozongshu:'发货总数',
  chekuan:'车款',
  shigonglex:'施工类型',
  weix:'维修',
  genghuan:'更换',
  peijianjine:'配件金额',
  yitonggshul:'已通过数量',
  yipeifushul:'已赔付数量',
  shenhezhuangt:'审核状态',
  peijianzioee:'配件总额',
  gongshifzonge:'工时费总额',
  xianggongclp:'向工厂申请理赔',
  hezuozong:'合作中',
  yizhjongzh:'已终止',
  lingshousquanc:'零售商全称',
  hezuozhuangt:'合作状态',
  wenjianminame:'文件名称',
   wenjian:'文件',
   fabuwendang:'发布文档',
   bianjiwendan:'编辑文档',
   tianjiachexing:'添加车型',
   caigoujiage:'采购价格',
   daijishushenhe:'待技术审核',
   erlunpej:'二轮车配件',
   silunpej:'四轮车配件',
   erlunzhengc:'二轮车整车',
   silunzhengc:'四轮车整车',
   erlunpejdd:'二轮车配件订单',
   silunpejdd:'四轮车配件订单',
   erlunzhengcdd:'二轮车整车订单',
   silunzhengcdd:'四轮车整车订单',
   gongchangsuopdh:'工厂索赔单号',
   zheshijiesuanjine:'结算金额',
   zhejsijiesuan:'结算',
   yijiesuanjine:'已结算金额',
   daijinsuanjin:'待结算金额',
   yuetiaozheng:'余额调整',
   zengjia:'增加',
   jiankou:'减扣',
   fahuozhangt:'发货状态',
   weiwancheng:'未完成',
   yiwancehng:'已完成',
   buxianzhi:'不限制',
   yishenql:'已申请',
   queddshanchuxuan:'确定删除选中配件?',
   plshanc:'批量删除',
    zhoubianq:'周边品',
    kuaijiedenglul:'快捷登陆',
    tijiaojhishushene:'提交技术审核',
    bohui:'驳回',
    jishubanpdduan:'技术判断',
    chepaihao:"车牌号",
    
    baoyangxinxx:"保养信息",
    baoyang:'保养',
qingshangchaunss:'请上传行驶证、里程表图片、故障件图片（维修需提供）',
chushenjuj:'初审拒绝',
shucujujyy:'请输入拒绝原因',
jishupand:'技术判定',
suopk:'索赔',
zhic:'支持',
nozhic:'不支持',
dadijishupd:'技术判定意见',
tyReapply:'同意审核结果',
yueikou:'余额抵扣',
xiaddanzhoukbil:'下单折扣比例',
shezhi:'设置',
yefy:'余额',
dczdddk:'单次最多抵扣订单金额',
zpnmji:'总计',
lingshousjianc:'零售商简称',
zhuanggjine:'转账金额',
fapiao:'发票',
xglshousshang:'修改零售商',
xiugailintishi:'修改零售商后，车辆档案的所属零售商将更新。',
xuanzelingshouss:'选择零售商',
dayinbiaoq:'打印标签',
zanwuquanx:'暂无权限',
beihuozhong:'备货中',
tianjiacheliang:'添加车辆',
piliangtianjial:'批量添加',
dangqzhibdaoqihijian:'当前质保到期时间',
yanchangqixian:'延长期限',
yinian:'1年',
liangnian:'2年',
sannian:'3年',
sinian:'4年',
wunian:'5年',
cheliangzongsshu:'车辆总数',
huruduochejiahaotihsi:'输入多个车架号用“，”隔开',
dantaiyongl:'单台用量',
shiwu:'实物',
xunijine:'虚拟金额',
caozuochengong:'操作成功',
peifufanghui:'赔付方式',
fanhui:'返回',
quxiaofahuoo:'取消发货',
zhekoudanjia:'折扣单价',
zhekoujine:'折扣金额',
mubantishi:'维护运输费、搬运费、证书费等费用模板，模板仅定义费用标准，适用经销商请在【经销商管理】中批量设置。',
addfeiyongmb:'新建费用模板',
mubanmingcheng:'模板名称',
yewylixinbg:'业务类型',
zhesyunshu:'运输费',
zheshibanyun:'搬运费',
zheshizhengshu:'证书费',
shuoming:'说明',
zheshitishia:'模板名称支持多语言输入，系统将根据用户语言自动显示对应的语言名称',
chuangjainmban:'创建模板',
feiyongmingx:'费用明细',
zhesqiy:'启用',
zhesty:'停用',
feiyongshezhi:'费用配置',
weipeuizhiu:'未配置',
erlunfuzeren:'二轮负责人',
silunfuzeren:'四轮负责人',
shouhoufuzeren:'售后负责人',
yiyzjiangxiaos:'已选择经销商',
szldtopshuoming:'为所选经销商配置不同业务类型的费用模板，保存后将覆盖原有配置。',
erluncfeiyu:'二轮车费用配置',
siluncfeiypz:'四轮车费用配置',
feiyongmuy:'费用模板',
mubancank:'模板费用明细（参考）',
feiyonglerx:'费用类型',
pzldbotshuom:'保存后，所选经销商的订单生成ERP时将自动带入新的费用配置，已生成订单不受影响。',
erlunc:'二轮车',
silunc:'四轮车',
  }, 

}
